const documentType = [
  { label: "Passport", value: "1" },
  { label: "National ID Card", value: "2" },
  { label: "Driving License", value: "3" },
  { label: "Valid Student ID Card", value: "4" },
  { label: "Any Other Govt. Issued Doc", value: "5" },
];
export default documentType;
